// noinspection SpellCheckingInspection

type TrustlyBanksType = Record<string, Record<string, string>>

export const TrustlyBanksData: TrustlyBanksType = {
  AT: {
    // Austria AT, AUT
    bkau: 'Bank Austria',
    ingd: 'bank99 (ex-ING)',
    bawa: 'BAWAG P.S.K.',
    easy: 'Easybank',
    giba: 'Erste Sparkasse George',
    ntsb: 'N26',
    rlnw: 'Raiffeisen',
    vboe: 'Volksbank'
  },
  CZ: {
    // Czech Republic CZ, CZE
    giba: 'Česká spořitelna'
  },
  DK: {
    // Denmark DK, DNK
    almb: 'Alm. Brand',
    alba: 'Arbejdernes Landsbank',
    daba: 'Danske Bank',
    djur: 'Djurslands Bank',
    hand: 'Handelsbanken',
    jyba: 'Jyske Bank',
    aakr: 'Kreditbanken',
    ndea: 'Nordea',
    nsbk: 'Nordfyns Bank',
    eban: 'Nordjyske Bank',
    nykb: 'Nykredit Bank',
    ring: 'Ringkjøbing Landbobank',
    esse: 'SEB',
    skjb: 'Skjern Bank',
    spno: 'Spar Nord Bank',
    vraa: 'Sparekassen Danmark',
    swes: 'Sparekassen Sjælland-Fyn',
    swed: 'Swedbank',
    sybk: 'Sydbank',
    veho: 'Vestjysk Bank'
  },
  EE: {
    // Estonia EE, EST
    parx: 'Citadele',
    ekrd: 'Coop Pank',
    fore: 'Danske Bank',
    lhvb: 'LHV Pank',
    riko: 'Luminor',
    ndea: 'Nordea',
    revo: 'Revolut',
    eeuh: 'SEB',
    haba: 'Swedbank'
  },
  FI: {
    // Finland FI, FIN
    hels: 'Aktia',
    daba: 'Danske Bank',
    hand: 'Handelsbanken',
    ndea: 'Nordea',
    okoy: 'OP',
    omsp: 'OmaSp',
    popf: 'POP Pankki',
    sban: 'S-Pankk',
    itel: 'Saastopankki',
    aaba: 'Ålandsbanken'
  },
  DE: {
    // Germany DE, DEU
    comd: 'Comdirect',
    coba: 'Commerzbank',
    dabb: 'DAB Bank',
    byla: 'DKB - Deutsche Kreditbank',
    deut: 'Deutsche Bank',
    fddo: 'Fidor Bank',
    hyve: 'HypoVereinsbank',
    ingd: 'ING-DiBa',
    ntsb: 'N26',
    nors: 'Norisbank',
    pbnk: 'Postbank',
    revo: 'Revolut',
    bsch: 'Santander',
    geno: 'Sparda-Bank',
    sskn: 'Sparkasse',
    cmci: 'Targobank',
    volk: 'Volksbank-Raiffeisenbank'
  },
  LV: {
    // Latvia LV, LVA
    parx: 'Citadele',
    riko: 'Luminor',
    revo: 'Revolut',
    unla: 'SEB',
    haba: 'Swedbank'
  },
  LT: {
    // Lithuania LT, LTU
    indu: 'Citadele',
    agbl: 'Luminor',
    revo: 'Revolut',
    cbvi: 'SEB',
    haba: 'Swedbank',
    cbsb: 'Šiaulių bankas'
  },
  NL: {
    // Netherlands NL, NLD
    abna: 'ABN AMRO',
    asnb: 'ASN Bank',
    ingb: 'ING',
    knab: 'Knab',
    rabo: 'Rabobank',
    rbrb: 'Regio Bank',
    snsb: 'SNS Bank',
    trio: 'Triodos'
  },
  NO: {
    // Norway NO, NOR
    kbno: 'BN Bank ASA',
    dnba: 'DNB',
    daba: 'Danske Bank',
    etne: 'Etne Sparebank',
    fana: 'Fana Sparebank',
    flek: 'Flekkefjord Sparebank',
    hand: 'Handelsbanken',
    haug: 'Haugesund Sparebank',
    klpk: 'KLP Banken',
    land: 'Landkreditt Bank AS',
    lill: 'Lillesands Sparebank',
    lusk: 'Luster Sparebank',
    ndea: 'Nordea',
    gjas: 'Nordea Direct',
    obos: 'OBOS-banken AS',
    ptaa: 'Pareto Bank ASA',
    sbak: 'Sbanken',
    skia: 'Skandiabanken',
    skaa: 'Skudenes & Aakra Sparebank',
    snow: 'SpareBank 1',
    sgfs: 'SpareBank 1 Gudbrandsdal',
    haal: 'SpareBank 1 Hallingdal Valdres',
    losk: 'SpareBank 1 Lom og Skjåk',
    modu: 'SpareBank 1 Modum',
    norv: 'SpareBank 1 Nordmøre',
    riri: 'SpareBank 1 Ringerike Hadeland',
    sptr: 'SpareBank 1 SMN',
    spro: 'SpareBank 1 SR-Bank',
    vold: 'SpareBank 1 Søre Sunnmøre',
    vefo: 'SpareBank 1 Sørøst-Norge (BV)',
    sptl: 'SpareBank 1 Sørøst-Norge (Telemark)',
    rygs: 'SpareBank 1 Østfold Akershus',
    shed: 'SpareBank 1 Østlandet',
    spar: 'Sparebanken Møre',
    sofj: 'Sparebanken Sogn og Fjordane',
    spso: 'Sparebanken Sør',
    spav: 'Sparebanken Vest',
    spoe: 'Sparebanken Øst',
    spsk: 'Spareskillingsbanken',
    swed: 'Swedbank',
    sogs: 'Søgne og Greipstad Sparebank',
    vosk: 'Voss Sparebank'
  },
  PL: {
    // Poland PL, POL
    albp: 'Alior Bank',
    ppab: 'BNP Paribas',
    pkop: 'Bank Pekao',
    pocz: 'Bank Pocztowy',
    citi: 'Citi Handlowy',
    agri: 'Credit Agricole',
    deut: 'Deutsche Bank Polska',
    gbgc: 'Getin Bank',
    ingb: 'ING Bank Śląski',
    ingo: 'Inteligo',
    bigb: 'Millennium Bank',
    brex: 'Orange Finanse',
    bpko: 'PKO Bank Polski',
    wbkp: 'Santander'
  },
  ES: {
    // Spain ES, ESP
    cagl: 'ABANCA',
    bbva: 'BBVA',
    popu: 'Banco Popular',
    bsab: 'Banco Sabadell',
    bsch: 'Banco Santander',
    cahm: 'Bankia',
    bkbk: 'Bankinter',
    caix: 'CaixaBank',
    evob: 'EVO Banco',
    ingd: 'ING',
    cazr: 'Ibercaja',
    bask: 'Kutxabank'
  },
  SE: {
    // Sweden SE, SWE
    daba: 'Danske Bank',
    forx: 'FOREX',
    hand: 'Handelsbanken',
    ibca: 'ICA Banken',
    ellf: 'Länsförsäkringar',
    ndea: 'Nordea',
    esse: 'SEB',
    skia: 'Skandiabanken',
    ssyd: 'Sparbanken Syd',
    swed: 'Swedbank (& Sparbankerna)',
    aaba: 'Ålandsbanken'
  },
  GB: {
    // Kingdom GB, GBR
    aibk: 'AIB',
    apah: 'Alpha FX',
    arbu: 'Arbuthnot Latham',
    bofi: 'Bank of Ireland UK',
    bofs: 'Bank of Scotland',
    barc: 'Barclays',
    hoab: 'C. Hoare & Co.',
    apsf: 'Cash Plus',
    cate: 'Cater Allen',
    chas: 'Chase UK',
    chel: 'Chelsea Building Society',
    citi: 'Citibank',
    clyd: 'Clydesdale Bank',
    cout: 'Coutts',
    daba: 'Danske Bank',
    hbuk: 'First Direct',
    midl: 'HSBC UK',
    hlfx: 'Halifax',
    icic: 'ICICI Bank UK',
    ives: 'Investec',
    hamb: 'Kleinwort Hambros',
    loyd: 'Lloyds Bank',
    mbna: 'MBNA',
    mymb: 'Metro Bank',
    monz: 'Monzo',
    nwbk: 'NatWest',
    naia: 'Nationwide',
    revo: 'Revolut',
    rbos: 'Royal Bank of Scotland',
    abby: 'Santander UK',
    svbk: 'Silicon Valley Bank UK',
    srlg: 'Starling Bank',
    tsbs: 'TSB Bank',
    tpfg: 'Tesco Bank',
    cpbk: 'The Co-operative Bank',
    cmbs: 'The Cumberland',
    clrb: 'Tide',
    ulsb: 'Ulster Bank',
    vqis: 'Vanquis Bank',
    nrnb: 'Virgin Money UK',
    trwi: 'Wise',
    york: 'Yorkshire Bank',
    yorb: 'Yorkshire Building Society'
  }
} as const
